export default __webpack_public_path__ + "static/media/private.356b2964.svg";